document.addEventListener('DOMContentLoaded', function () {
    const addToCartBtn = document.querySelector('.product-form__footer');
    const productVariantDetails = document.querySelector('.product-form__body');
    const targetElement = document.querySelector('.js-product-form__description.product-form__description');
    const originalContainer = document.querySelector('.product-form');
    const mobileBreakpoint = 768; // Mobile breakpoint width

    function moveElement(element, target, originalContainer) {
        if (window.innerWidth <= mobileBreakpoint) {
            if (element && target && !target.contains(element)) {
                target.prepend(element);
            }
        } else {
            if (element && originalContainer && !originalContainer.contains(element)) {
                originalContainer.append(element);
            }
        }
    }

    function applyMobileStyles() {
        if (window.innerWidth <= mobileBreakpoint) {
            if (addToCartBtn) {
                addToCartBtn.style.marginBottom = '1rem';
            }
        } else {
            if (addToCartBtn) {
                addToCartBtn.style.marginBottom = '';
            }
        }
    }

    function moveElements() {
        if (!originalContainer) {
            console.error('Original container (.product-form) not found.');
            return;
        }

        moveElement(addToCartBtn, targetElement, originalContainer);
        moveElement(productVariantDetails, targetElement, originalContainer);

        applyMobileStyles();
    }

    function handleDescriptionClick(event) {
        // Check if the clicked element is a button (either "READ MORE" or "READ LESS")
        if (
            event.target.closest('.js-product-form__open-description-btn') ||
            event.target.closest('.js-product-form__close-description-btn')
        ) {
            console.log('Description button clicked. Ensuring elements are correctly positioned.');
            moveElements();
        }
    }

    let resizeTimeout;
    function debounceResize() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(moveElements, 200);
    }

    // Initial load
    moveElements();

    // Handle resize events
    window.addEventListener('resize', debounceResize);

    // Listen for clicks on the parent container
    if (targetElement) {
        targetElement.addEventListener('click', handleDescriptionClick);
    }
});
